// @flow

export const DRIFT_EVENTS = {
  'conversation:buttonClicked': {
    action: 'Button Clicked',
    label: (payload: Object) => `Playbook ID: ${payload.playbookId}, Text: ${payload.buttonBody}`,
    nonInteraction: false
  },
  'conversation:firstInteraction': {
    action: 'First Interaction',
    label: (payload: Object) => undefined,
    nonInteraction: false
  },
  'conversation:playbookClicked': {
    action: 'Playbook Clicked',
    label: (payload: Object) => `Playbook ID: ${payload.playbookId}`,
    nonInteraction: false
  },
  'conversation:playbookFired': {
    action: 'Playbook Fired',
    label: (payload: Object) => `Playbook ID: ${payload.playbookId}`,
    nonInteraction: true
  },
  'conversation:playbookDismissed': {
    action: 'Playbook Dismissed',
    label: (payload: Object) => `Playbook ID: ${payload.playbookId}`,
    nonInteraction: false
  },
  'message': {
    action: 'Message Received',
    label: (payload: Object) => `Conversation: ${payload.conversationId}`,
    nonInteraction: true
  },
  'message:sent': {
    action: 'Message Sent',
    label: (payload: Object) => `Conversation: ${payload.conversationId}`,
    nonInteraction: false
  },
  'startConversation': {
    action: 'Chat Started',
    label: (payload: Object) => undefined,
    nonInteraction: false
  },
  'emailCapture': {
    action: 'Email Captured',
    label: (payload: Object) => payload.playbookId ? `Playbook ID: ${payload.playbookId}` : '',
    nonInteraction: false
  },
  'phoneCapture': {
    action: 'Phone Number Capture',
    label: (payload: Object) => payload.playbookId ? `Playbook ID: ${payload.playbookId}` : '',
    nonInteraction: false
  },
  'scheduling:meetingBooked': {
    action: 'Meeting Booked',
    label: (payload: Object) => payload.playbookId ? `Playbook ID: ${payload.playbookId}` : '',
    nonInteraction: false
  },
}
